export class Globals {
  checkCompare: any[];
}
export interface TransactionFilters {
  [key: string]: string;
}
